import React from 'react';
import { Wine, Droplets, Sparkles, Sun, Cherry, Beer, Cigarette, Gift, GlassWater } from 'lucide-react';
import { businessData } from '../data/mock';

const iconMap = {
  Wine: Wine,
  GlassWater: GlassWater,
  Martini: Droplets,
  Sparkles: Sparkles,
  Sun: Sun,
  Cherry: Cherry,
  Beer: Beer,
  Cigarette: Cigarette,
  Gift: Gift,
};

const Products = () => {
  return (
    <section id="productos" className="py-20 md:py-28 bg-[var(--color-cream)]">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[var(--color-wine)] font-medium mb-2 tracking-wider uppercase text-sm">
            Lo que ofrecemos
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-[var(--color-black)] mb-4">
            Nuestros Productos
          </h2>
          <p className="text-[var(--color-gray)] max-w-xl mx-auto">
            Descubrí nuestra selección de bebidas premium y productos exclusivos
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6">
          {businessData.products.map((product, index) => {
            const IconComponent = iconMap[product.icon] || Wine;
            return (
              <div
                key={product.name}
                className="group relative bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-[var(--color-cream-dark)]"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[var(--color-wine)]/10 flex items-center justify-center mb-4 group-hover:bg-[var(--color-wine)] transition-colors duration-300">
                    <IconComponent
                      size={32}
                      className="text-[var(--color-wine)] group-hover:text-[var(--color-cream)] transition-colors duration-300"
                    />
                  </div>
                  <h3 className="text-lg md:text-xl font-serif text-[var(--color-black)] group-hover:text-[var(--color-wine)] transition-colors">
                    {product.name}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>

        {/* Payment Methods */}
        <div className="mt-16 text-center">
          <p className="text-[var(--color-gray)] mb-4">Medios de pago aceptados:</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {businessData.paymentMethods.map((method) => (
              <span
                key={method}
                className="bg-white px-4 py-2 rounded-full text-sm font-medium text-[var(--color-black)] border border-[var(--color-cream-dark)] shadow-sm"
              >
                {method}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
